import React, { useEffect, useState } from 'react';
import { styled, Typography } from '@mui/material';

const ScrollDownContainer = styled('div')`
  transition: opacity 0.5s;
  padding: 20px 0;
`;

const Arrow = styled('div')`
  font-size: 24px;
  animation: bounce 2s infinite;
  display: inline-block;

  @keyframes bounce {
    0%,
    20%,
    50%,
    80%,
    100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-10px);
    }
    60% {
      transform: translateY(-5px);
    }
  }
`;

const Text = styled(Typography)`
  font-size: 16px;
  margin-top: 5px;
`;

const ScrollDown: React.FC = () => {
  const [opacity, setOpacity] = useState(1);
  const [isVisible, setIsVisible] = useState(false);
  const [hasFadedOut, setHasFadedOut] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (hasFadedOut) return;

      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const element = document.querySelector('.scroll-down');
      if (!element) return;

      const rect = element.getBoundingClientRect();
      const elementTop = rect.top + scrollPosition;
      const elementBottom = elementTop + rect.height;

      if (scrollPosition + windowHeight >= elementBottom) {
        setIsVisible(true);
      }

      if (isVisible) {
        const newOpacity = Math.max(
          1 - (scrollPosition - elementTop + windowHeight) / windowHeight,
          0,
        );
        setOpacity(newOpacity);
        if (newOpacity === 0) {
          setHasFadedOut(true);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isVisible, hasFadedOut]);

  return (
    <ScrollDownContainer className="scroll-down" style={{ opacity }}>
      <Typography color="white">
        <Arrow>↓</Arrow> Scroll down
      </Typography>
    </ScrollDownContainer>
  );
};

export default ScrollDown;
